var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name === 'uniqueItems')?_c('div',[_c('unique-items',{attrs:{"requirement":_vm.requirement,"packages":_vm.packages,"deals":_vm.deals,"products":_vm.products}})],1):_vm._e(),_vm._v(" "),(_vm.name === 'minimumOrderTotal')?_c('div',[_c('minimum-order-total',{attrs:{"requirement":_vm.requirement}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }